module.exports = __webpack_public_path__ + "img/product-shot_03_loading.6ff7d9f5.jpg";